import React from 'react';
import { connect } from 'react-redux';
import { BackButton } from './BackButton/BackButton';
import { NavLink, withRouter } from 'react-router-dom';
import { selectCheckPermission } from 'HelperFunctions/locations';
import SerializedProductNavLink from 'Components/products/SerializedProductNavLink';
import useIsScreenWidthBelow from '../../hooks/useIsScreenWidthBelow';
import {
  productTypeToUrl,
  capitalPluralInventory,
  capitalSingularInventory
} from "../../constants/displayConstants";

const InventoryNavLinks = ({
  params,
  product,
  history,
  business,
  checkPermission,
}) => {
  const usageUnitsAvailable =
    product?.usageUnits && product?.usageUnits?.length > 0;

  const isMobile = useIsScreenWidthBelow(768);

  return (
    <h1>
      {isMobile ? (
        <BackButton
          title={`Back to ${capitalPluralInventory[product.productType]}`}
          onClick={() =>
            history.push(`/inventory/${productTypeToUrl[product.productType]}`)
          }
        />
      ) : (
        capitalSingularInventory[product.productType]
      )}
      <div className='headerNav'>
        <NavLink
          id='item_details'
          activeClassName='selected'
          exact
          to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}`}
        >
          {capitalSingularInventory[product.productType]} Details
        </NavLink>
        {product?.productType !== 'accessories' && checkPermission('make_shareable') && (
          <NavLink
            id='marketing'
            activeClassName='selected'
            to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}/shared`}
          >
            Marketing
          </NavLink>
        )}
        {product?.serializationStatus !== 'standard' &&
          checkPermission('view_serialized_tab_inventory') && (
            <SerializedProductNavLink product={product} params={params} />
          )}
        {product?.serializationStatus === 'serialized' &&
          usageUnitsAvailable && (
            <NavLink
              id='serialized'
              activeClassName='selected'
              to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}/usage`}
            >
              Usage
            </NavLink>
          )}
        {product?.serializationStatus === 'serialized' &&
          business.permissions.scheduledMaintenanceEnabled && (
            <NavLink
              id='scheduled_maintenance'
              activeClassName='selected'
              to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}/scheduled_maintenance`}
            >
              Scheduled Maintenance
            </NavLink>
          )}
        {product?.businessInfo?.multilocationEnabled && (
          <NavLink
            id='multilocation'
            activeClassName='selected'
            to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}/multilocation`}
          >
            Multilocation
          </NavLink>
        )}
      </div>
    </h1>
  );
};

const mapStateToProps = (state) => {
  const { business } = state.business;

  return { business, checkPermission: selectCheckPermission(state) };
};

export default withRouter(connect(mapStateToProps, null)(InventoryNavLinks));
